import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import FormTextField from '../../../../components/FormTextField';
import { useTheme } from '@emotion/react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import FormSelectField from '../../../../components/FormSelectField';
import { buttonStyle1, buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { initCompanyDetails, initTraderDetails } from '../../../../redux/features/authSlice';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    // alignItems: 'center',
    // WebkitAlignItems: 'center',
    // WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
  },
};

const validationSchema = yup.object({
  displayName: yup.string('Display Name').min(3, 'Display Name should be atleast 3 characters').max(30, 'Maximum Character Limit 30').required(' '),
  traderName: yup.string('Trader Name').min(3, 'Trader Name should be atleast 3 characters').max(100, 'Maximum Character Limit 100').required(' '),
  traderAddress: yup.string('Trader Name').min(1, 'Trader Address should be atleast 3 characters').max(300, 'Maximum Character Limit 300').required(' '),
  countryName: yup.string('Country Name').required(' '),
  stateName: yup.string('State Name').required(' '),
  traderWebsite: yup
    .string('Website')
    .matches(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi, 'Enter valid url!'),
  zipCode: yup.string('Entity Type').required().min(1, 'Zip Code should be atleast 1 characters').max(8, 'Maximum Character Limit 8').required(' '),
});

const entityTypes = [
  {
    entityId: 'private',
    entityName: 'Private',
  },
  {
    entityId: 'public',
    entityName: 'Public',
  },
  {
    entityId: 'others',
    entityName: 'Others',
  },
];

export default function EditTraderProfile({ modelOpen, handleClose }) {
  const theme = useTheme();
  const formRef = useRef();
  const dispatch = useDispatch();
  const { userId, companyDetails, user } = useSelector((state) => state.auth);
  const { countryList } = useSelector((state) => state.layout);
  const [countryId, setCountryId] = useState(null);
  const [stateList, setStateList] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    if (companyDetails && companyDetails?.countryName) {
      const idObj = countryList.filter((res) => res.countryName === companyDetails?.countryName)[0];
      if (idObj) {
        setCountryId(idObj._id);
      }
    }
  }, [companyDetails?.countryName]);

  useEffect(() => {
    if (countryId) {
      getStateList();
    }
  }, [countryId]);

  const getStateList = async () => {
    const response = await appapi.get(`common/state/${countryId}`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setStateList(data.response || []);
      } else {
        setStateList([]);
      }
    }
  };

  const handleUpdateCompany = async (values) => {
    dispatch(setLoading(true));
    const payload = values;

    const response = await appapi.put(`/trader/editOnboardTraderDetails/${companyDetails?._id}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        dispatch(initTraderDetails());
        handleClose();
        showmessage(data.message, 'success');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return modelOpen ? (
    <Formik
      innerRef={formRef}
      enableReinitialize={false}
      initialValues={{
        traderName: companyDetails?.traderName || '',
        displayName: companyDetails?.displayName || '',
        traderAddress: companyDetails?.traderAddress || '',
        traderWebsite: companyDetails?.traderWebsite || '',
        countryName: companyDetails?.countryName || undefined,
        stateName: companyDetails?.stateName || undefined,
        zipCode: companyDetails?.zipCode || undefined,
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleUpdateCompany(values);
      }}
    >
      {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
        <Form autoComplete="off">
          <Dialog
            sx={sx}
            open={modelOpen}
            scroll="paper"
          >
            <DialogTitle
              className="fw-medium fs-14 ff-Roboto !uppercase"
              color={theme.palette.primary.text}
              sx={{ m: 0, p: 2 }}
              id="customized-dialog-title"
            >
              {t('Company details')}
            </DialogTitle>
            <IconButton
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <ClearIcon
                style={{ transform: 'scale(1)', color: 'rgba(20, 40, 90,0.5)' }}
                onClick={() => {
                  handleClose();
                }}
              />
            </IconButton>
            <DialogContent dividers>
              <Stack
                style={{ backgroundColor: 'white', borderRadius: '8px' }}
                className=""
              >
                <Stack>
                  <FormTextField
                    outlineLabel={t('Company name')}
                    name="traderName"
                    requiredMark={false}
                    whiteSpace={true}
                    inputProps={{ maxLength: 200 }}
                    disabled={true}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Display name')}
                    name="displayName"
                    requiredMark={false}
                    whiteSpace={true}
                    inputProps={{ maxLength: 200 }}
                    disabled={true}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Website')}
                    name="traderWebsite"
                    requiredMark={false}
                    lowerCase={true}
                    inputProps={{ maxLength: 200 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Address')}
                    name="traderAddress"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 301 }}
                  />
                </Stack>
                <Stack>
                  <FormSelectField
                    name="countryName"
                    label={t('Country') + '*'}
                    onSelect={(e) => {
                      setFieldValue('stateName', undefined);
                      const idObj = countryList.filter((res) => res.countryName === e)[0];
                      if (idObj) {
                        setCountryId(idObj._id);
                      }
                    }}
                  >
                    {countryList?.map((item) => (
                      <MenuItem
                        key={item.countryName}
                        value={item.countryName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.countryName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormSelectField
                    name="stateName"
                    label={t('State/Province') + ' *'}
                  >
                    {stateList?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>No Data Found</em>
                      </MenuItem>
                    )}
                    {stateList?.map((item) => (
                      <MenuItem
                        key={item.stateName}
                        value={item.stateName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.stateName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>

                <Stack>
                  <FormTextField
                    outlineLabel={t('Zip Code')}
                    fullWidth
                    id={'zipCode'}
                    name="zipCode"
                    inputProps={{ maxLength: 8 }}
                    requiredMark={true}
                    sx={{ marginBottom: '25px !important' }}
                  ></FormTextField>
                </Stack>
              </Stack>
            </DialogContent>
            <DialogActions>
              <Button
                type="button"
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    textTransform:'uppercase',
                    '&:hover': {},
                  },
                ]}
                onClick={handleClose}
              >
                {t('Close')}
              </Button>
              <Button
                disabled={!(dirty && isValid)}
                onClick={() => formRef?.current?.handleSubmit()}
                variant="contained"
                sx={[
                  buttonStyle2,
                  {
                    color: '#fff',
                    textTransform:'uppercase',
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                      backgroundColor: theme.palette.background.main,
                      color: '#fff',
                      textTransform:'uppercase'
                    },
                    '&:disabled': {
                      color: 'rgba(255,255,255,0.5)',
                      backgroundColor: theme.palette.primary.main,
                    },
                  },
                ]}
              >
               {t('Update')}
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  ) : null;
}
